(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-category-slider"] && !Shopify.designMode) return;
  try {
    window.addEventListener("load", function () {
    const collection_icon_swiper = new Swiper('#featured-collection-icons-slider .swiper', {
      loop: false,
      autoplay: false,
      disableOnInteraction: false,
      slidesPerView: 2.5,
      slidesPerGroup: 2,
      spaceBetween: 30,
      centeredSlides: false,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: '#featured-collection-icons-slider .swiper-button-next',
        prevEl: '#featured-collection-icons-slider .swiper-button-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        768: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        992: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1200: {
          slidesPerView: 5,
          slidesPerGroup: 5,
        },
        1400: {
          slidesPerView: 6,
          slidesPerGroup: 6,
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
